/**
 *
 * Popover
 *
 */

import React from 'react';
import { Popover as CustomPopover } from 'antd';
import './style.less';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

function Popover({
  title = '',
  content,
  position = 'top',
  overlayClassName,
  ...rest
}: any) {
  return (
    <CustomPopover
      title={title}
      content={content}
      placement={position}
      overlayClassName={overlayClassName}
    >
      {rest.children}
    </CustomPopover>
  );
}

export default Popover;
